function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var b = Object.defineProperty;
var w = function w(o, e, t) {
  return e in o ? b(o, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : o[e] = t;
};
var n = function n(o, e, t) {
  return w(o, _typeof(e) != "symbol" ? e + "" : e, t);
};
import { throttle as P } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/function/throttle.js";
import { isElement as g } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/predicate/isElement.js";
import { cloneDeepWith as x } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/object/cloneDeepWith.js"; /**
                                                                                                                                   * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
                                                                                                                                   * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
                                                                                                                                   */ /**
                                                                                                                                      * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
                                                                                                                                      * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
                                                                                                                                      */
var f = /*#__PURE__*/function () {
  function f(e) {
    var _this = this;
    _classCallCheck(this, f);
    n(this, "crashes", []);
    n(this, "state", "initializing");
    n(this, "_crashNumberLimit");
    n(this, "_now", Date.now);
    n(this, "_minimumNonErrorTimePeriod");
    n(this, "_boundErrorHandler");
    n(this, "_listeners");
    if (this.crashes = [], this._crashNumberLimit = typeof e.crashNumberLimit == "number" ? e.crashNumberLimit : 3, this._minimumNonErrorTimePeriod = typeof e.minimumNonErrorTimePeriod == "number" ? e.minimumNonErrorTimePeriod : 5e3, this._boundErrorHandler = function (t) {
      var s = "error" in t ? t.error : t.reason;
      s instanceof Error && _this._handleError(s, t);
    }, this._listeners = {}, !this._restart) throw new Error("The Watchdog class was split into the abstract `Watchdog` class and the `EditorWatchdog` class. Please, use `EditorWatchdog` if you have used the `Watchdog` class previously.");
  }
  return _createClass(f, [{
    key: "destroy",
    value: function destroy() {
      this._stopErrorHandling(), this._listeners = {};
    }
  }, {
    key: "on",
    value: function on(e, t) {
      this._listeners[e] || (this._listeners[e] = []), this._listeners[e].push(t);
    }
  }, {
    key: "off",
    value: function off(e, t) {
      this._listeners[e] = this._listeners[e].filter(function (s) {
        return s !== t;
      });
    }
  }, {
    key: "_fire",
    value: function _fire(e) {
      var s = this._listeners[e] || [];
      for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        t[_key - 1] = arguments[_key];
      }
      var _iterator = _createForOfIteratorHelper(s),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var r = _step.value;
          r.apply(this, [null].concat(t));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "_startErrorHandling",
    value: function _startErrorHandling() {
      window.addEventListener("error", this._boundErrorHandler), window.addEventListener("unhandledrejection", this._boundErrorHandler);
    }
  }, {
    key: "_stopErrorHandling",
    value: function _stopErrorHandling() {
      window.removeEventListener("error", this._boundErrorHandler), window.removeEventListener("unhandledrejection", this._boundErrorHandler);
    }
  }, {
    key: "_handleError",
    value: function _handleError(e, t) {
      if (this._shouldReactToError(e)) {
        this.crashes.push({
          message: e.message,
          stack: e.stack,
          filename: t instanceof ErrorEvent ? t.filename : void 0,
          lineno: t instanceof ErrorEvent ? t.lineno : void 0,
          colno: t instanceof ErrorEvent ? t.colno : void 0,
          date: this._now()
        });
        var s = this._shouldRestart();
        this.state = "crashed", this._fire("stateChange"), this._fire("error", {
          error: e,
          causesRestart: s
        }), s ? this._restart() : (this.state = "crashedPermanently", this._fire("stateChange"));
      }
    }
  }, {
    key: "_shouldReactToError",
    value: function _shouldReactToError(e) {
      return e.is && e.is("CKEditorError") && e.context !== void 0 && e.context !== null && this.state === "ready" && this._isErrorComingFromThisItem(e);
    }
  }, {
    key: "_shouldRestart",
    value: function _shouldRestart() {
      if (this.crashes.length <= this._crashNumberLimit) return !0;
      var e = this.crashes[this.crashes.length - 1].date,
        t = this.crashes[this.crashes.length - 1 - this._crashNumberLimit].date;
      return (e - t) / this._crashNumberLimit > this._minimumNonErrorTimePeriod;
    }
  }]);
}();
/**
* @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/
function _(o) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
  var t = [o],
    s = new Set();
  var r = 0;
  for (; t.length > r;) {
    var i = t[r++];
    if (!(s.has(i) || !C(i) || e.has(i))) if (s.add(i), Symbol.iterator in i) try {
      var _iterator2 = _createForOfIteratorHelper(i),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var a = _step2.value;
          t.push(a);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    } catch (_unused) {} else for (var _a in i) _a !== "defaultValue" && t.push(i[_a]);
  }
  return s;
}
function C(o) {
  var e = Object.prototype.toString.call(o),
    t = _typeof(o);
  return !(t === "number" || t === "boolean" || t === "string" || t === "symbol" || t === "function" || e === "[object Date]" || e === "[object RegExp]" || e === "[object Module]" || o === void 0 || o === null || o._watchdogExcluded || o instanceof EventTarget || o instanceof Event);
}
function p(o, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Set();
  if (o === e && v(o)) return !0;
  var s = _(o, t),
    r = _(e, t);
  var _iterator3 = _createForOfIteratorHelper(s),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var i = _step3.value;
      if (r.has(i)) return !0;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return !1;
}
function v(o) {
  return _typeof(o) == "object" && o !== null;
}
var N = /*#__PURE__*/function (_f) {
  function N(t) {
    var _this2;
    var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, N);
    _this2 = _callSuper(this, N, [s]);
    n(_this2, "_editor", null);
    n(_this2, "_lifecyclePromise", null);
    n(_this2, "_throttledSave");
    n(_this2, "_data");
    n(_this2, "_lastDocumentVersion");
    n(_this2, "_elementOrData");
    n(_this2, "_initUsingData", !0);
    n(_this2, "_editables", {});
    n(_this2, "_config");
    n(_this2, "_excludedProps");
    _this2._throttledSave = P(_this2._save.bind(_this2), typeof s.saveInterval == "number" ? s.saveInterval : 5e3), t && (_this2._creator = function (r, i) {
      return t.create(r, i);
    }), _this2._destructor = function (r) {
      return r.destroy();
    };
    return _this2;
  }
  _inherits(N, _f);
  return _createClass(N, [{
    key: "editor",
    get: function get() {
      return this._editor;
    }
  }, {
    key: "_item",
    get: function get() {
      return this._editor;
    }
  }, {
    key: "setCreator",
    value: function setCreator(t) {
      this._creator = t;
    }
  }, {
    key: "setDestructor",
    value: function setDestructor(t) {
      this._destructor = t;
    }
  }, {
    key: "_restart",
    value: function _restart() {
      var _this3 = this;
      return Promise.resolve().then(function () {
        return _this3.state = "initializing", _this3._fire("stateChange"), _this3._destroy();
      }).catch(function (t) {
        console.error("An error happened during the editor destroying.", t);
      }).then(function () {
        var t = {},
          s = [],
          r = _this3._config.rootsAttributes || {},
          i = {};
        for (var _i = 0, _Object$entries = Object.entries(_this3._data.roots); _i < _Object$entries.length; _i++) {
          var _ref = _Object$entries[_i];
          var _ref2 = _slicedToArray(_ref, 2);
          var c = _ref2[0];
          var h = _ref2[1];
          h.isLoaded ? (t[c] = "", i[c] = r[c] || {}) : s.push(c);
        }
        var a = _objectSpread(_objectSpread({}, _this3._config), {}, {
          extraPlugins: _this3._config.extraPlugins || [],
          lazyRoots: s,
          rootsAttributes: i,
          _watchdogInitialData: _this3._data
        });
        return delete a.initialData, a.extraPlugins.push(S), _this3._initUsingData ? _this3.create(t, a, a.context) : g(_this3._elementOrData) ? _this3.create(_this3._elementOrData, a, a.context) : _this3.create(_this3._editables, a, a.context);
      }).then(function () {
        _this3._fire("restart");
      });
    }
  }, {
    key: "create",
    value: function create() {
      var _this4 = this;
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._elementOrData;
      var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._config;
      var r = arguments.length > 2 ? arguments[2] : undefined;
      return this._lifecyclePromise = Promise.resolve(this._lifecyclePromise).then(function () {
        return _superPropGet(N, "_startErrorHandling", _this4, 3)([]), _this4._elementOrData = t, _this4._initUsingData = typeof t == "string" || Object.keys(t).length > 0 && typeof Object.values(t)[0] == "string", _this4._config = _this4._cloneEditorConfiguration(s) || {}, _this4._config.context = r, _this4._creator(t, _this4._config);
      }).then(function (i) {
        _this4._editor = i, i.model.document.on("change:data", _this4._throttledSave), _this4._lastDocumentVersion = i.model.document.version, _this4._data = _this4._getData(), _this4._initUsingData || (_this4._editables = _this4._getEditables()), _this4.state = "ready", _this4._fire("stateChange");
      }).finally(function () {
        _this4._lifecyclePromise = null;
      }), this._lifecyclePromise;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this5 = this;
      return this._lifecyclePromise = Promise.resolve(this._lifecyclePromise).then(function () {
        return _this5.state = "destroyed", _this5._fire("stateChange"), _superPropGet(N, "destroy", _this5, 3)([]), _this5._destroy();
      }).finally(function () {
        _this5._lifecyclePromise = null;
      }), this._lifecyclePromise;
    }
  }, {
    key: "_destroy",
    value: function _destroy() {
      var _this6 = this;
      return Promise.resolve().then(function () {
        _this6._stopErrorHandling(), _this6._throttledSave.cancel();
        var t = _this6._editor;
        return _this6._editor = null, t.model.document.off("change:data", _this6._throttledSave), _this6._destructor(t);
      });
    }
  }, {
    key: "_save",
    value: function _save() {
      var t = this._editor.model.document.version;
      try {
        this._data = this._getData(), this._initUsingData || (this._editables = this._getEditables()), this._lastDocumentVersion = t;
      } catch (s) {
        console.error(s, "An error happened during restoring editor data. Editor will be restored from the previously saved data.");
      }
    }
  }, {
    key: "_setExcludedProperties",
    value: function _setExcludedProperties(t) {
      this._excludedProps = t;
    }
  }, {
    key: "_getData",
    value: function _getData() {
      var t = this._editor,
        s = t.model.document.roots.filter(function (h) {
          return h.isAttached() && h.rootName != "$graveyard";
        }),
        r = t.plugins,
        i = r.has("CommentsRepository") && r.get("CommentsRepository"),
        a = r.has("TrackChanges") && r.get("TrackChanges"),
        c = {
          roots: {},
          markers: {},
          commentThreads: JSON.stringify([]),
          suggestions: JSON.stringify([])
        };
      s.forEach(function (h) {
        c.roots[h.rootName] = {
          content: JSON.stringify(Array.from(h.getChildren())),
          attributes: JSON.stringify(Array.from(h.getAttributes())),
          isLoaded: h._isLoaded
        };
      });
      var _iterator4 = _createForOfIteratorHelper(t.model.markers),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var h = _step4.value;
          h._affectsData && (c.markers[h.name] = {
            rangeJSON: h.getRange().toJSON(),
            usingOperation: h._managedUsingOperations,
            affectsData: h._affectsData
          });
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return i && (c.commentThreads = JSON.stringify(i.getCommentThreads({
        toJSON: !0,
        skipNotAttached: !0
      }))), a && (c.suggestions = JSON.stringify(a.getSuggestions({
        toJSON: !0,
        skipNotAttached: !0
      }))), c;
    }
  }, {
    key: "_getEditables",
    value: function _getEditables() {
      var t = {};
      var _iterator5 = _createForOfIteratorHelper(this.editor.model.document.getRootNames()),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var s = _step5.value;
          var r = this.editor.ui.getEditableElement(s);
          r && (t[s] = r);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      return t;
    }
  }, {
    key: "_isErrorComingFromThisItem",
    value: function _isErrorComingFromThisItem(t) {
      return p(this._editor, t.context, this._excludedProps);
    }
  }, {
    key: "_cloneEditorConfiguration",
    value: function _cloneEditorConfiguration(t) {
      return x(t, function (s, r) {
        if (g(s) || r === "context") return s;
      });
    }
  }]);
}(f);
var S = /*#__PURE__*/function () {
  function S(e) {
    _classCallCheck(this, S);
    n(this, "editor");
    n(this, "_data");
    this.editor = e, this._data = e.config.get("_watchdogInitialData");
  }
  return _createClass(S, [{
    key: "init",
    value: function init() {
      var _this7 = this;
      this.editor.data.on("init", function (e) {
        e.stop(), _this7.editor.model.enqueueChange({
          isUndoable: !1
        }, function (t) {
          _this7._restoreCollaborationData(), _this7._restoreEditorData(t);
        }), _this7.editor.data.fire("ready");
      }, {
        priority: 999
      });
    }
  }, {
    key: "_createNode",
    value: function _createNode(e, t) {
      if ("name" in t) {
        var s = e.createElement(t.name, t.attributes);
        if (t.children) {
          var _iterator6 = _createForOfIteratorHelper(t.children),
            _step6;
          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var r = _step6.value;
              s._appendChild(this._createNode(e, r));
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
        }
        return s;
      } else return e.createText(t.data, t.attributes);
    }
  }, {
    key: "_restoreEditorData",
    value: function _restoreEditorData(e) {
      var _this8 = this;
      var t = this.editor;
      Object.entries(this._data.roots).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          s = _ref4[0],
          _ref4$ = _ref4[1],
          r = _ref4$.content,
          i = _ref4$.attributes;
        var a = JSON.parse(r),
          c = JSON.parse(i),
          h = t.model.document.getRoot(s);
        var _iterator7 = _createForOfIteratorHelper(c),
          _step7;
        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _ref5 = _step7.value;
            var _ref6 = _slicedToArray(_ref5, 2);
            var d = _ref6[0];
            var u = _ref6[1];
            e.setAttribute(d, u, h);
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
        var _iterator8 = _createForOfIteratorHelper(a),
          _step8;
        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var _d = _step8.value;
            var _u = _this8._createNode(e, _d);
            e.insert(_u, h, "end");
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
      }), Object.entries(this._data.markers).forEach(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
          s = _ref8[0],
          r = _ref8[1];
        var i = t.model.document,
          _r$rangeJSON = r.rangeJSON,
          a = _r$rangeJSON.start,
          c = _r$rangeJSON.end,
          h = _objectWithoutProperties(r, ["rangeJSON"]),
          d = i.getRoot(a.root),
          u = e.createPositionFromPath(d, a.path, a.stickiness),
          y = e.createPositionFromPath(d, c.path, c.stickiness),
          E = e.createRange(u, y);
        e.addMarker(s, _objectSpread({
          range: E
        }, h));
      });
    }
  }, {
    key: "_restoreCollaborationData",
    value: function _restoreCollaborationData() {
      var _this9 = this;
      var e = JSON.parse(this._data.commentThreads),
        t = JSON.parse(this._data.suggestions);
      e.forEach(function (s) {
        var r = _this9.editor.config.get("collaboration.channelId"),
          i = _this9.editor.plugins.get("CommentsRepository");
        i.hasCommentThread(s.threadId) && i.getCommentThread(s.threadId).remove(), i.addCommentThread(_objectSpread({
          channelId: r
        }, s));
      }), t.forEach(function (s) {
        var r = _this9.editor.plugins.get("TrackChangesEditing");
        if (r.hasSuggestion(s.id)) {
          var i = r.getSuggestion(s.id);
          i.attributes = s.attributes;
        } else r.addSuggestionData(s);
      });
    }
  }]);
}();
var l = Symbol("MainQueueId");
var R = /*#__PURE__*/function (_f2) {
  function R(t) {
    var _this0;
    var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, R);
    _this0 = _callSuper(this, R, [s]);
    n(_this0, "_watchdogs", new Map());
    n(_this0, "_watchdogConfig");
    n(_this0, "_context", null);
    n(_this0, "_contextProps", new Set());
    n(_this0, "_actionQueues", new T());
    n(_this0, "_contextConfig");
    n(_this0, "_item");
    _this0._watchdogConfig = s, _this0._creator = function (r) {
      return t.create(r);
    }, _this0._destructor = function (r) {
      return r.destroy();
    }, _this0._actionQueues.onEmpty(function () {
      _this0.state === "initializing" && (_this0.state = "ready", _this0._fire("stateChange"));
    });
    return _this0;
  }
  _inherits(R, _f2);
  return _createClass(R, [{
    key: "setCreator",
    value: function setCreator(t) {
      this._creator = t;
    }
  }, {
    key: "setDestructor",
    value: function setDestructor(t) {
      this._destructor = t;
    }
  }, {
    key: "context",
    get: function get() {
      return this._context;
    }
  }, {
    key: "create",
    value: function create() {
      var _this1 = this;
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this._actionQueues.enqueue(l, function () {
        return _this1._contextConfig = t, _this1._create();
      });
    }
  }, {
    key: "getItem",
    value: function getItem(t) {
      return this._getWatchdog(t)._item;
    }
  }, {
    key: "getItemState",
    value: function getItemState(t) {
      return this._getWatchdog(t).state;
    }
  }, {
    key: "add",
    value: function add(t) {
      var _this10 = this;
      var s = m(t);
      return Promise.all(s.map(function (r) {
        return _this10._actionQueues.enqueue(r.id, function () {
          if (_this10.state === "destroyed") throw new Error("Cannot add items to destroyed watchdog.");
          if (!_this10._context) throw new Error("Context was not created yet. You should call the `ContextWatchdog#create()` method first.");
          var i;
          if (_this10._watchdogs.has(r.id)) throw new Error("Item with the given id is already added: '".concat(r.id, "'."));
          if (r.type === "editor") return i = new N(null, _this10._watchdogConfig), i.setCreator(r.creator), i._setExcludedProperties(_this10._contextProps), r.destructor && i.setDestructor(r.destructor), _this10._watchdogs.set(r.id, i), i.on("error", function (a, _ref9) {
            var c = _ref9.error,
              h = _ref9.causesRestart;
            _this10._fire("itemError", {
              itemId: r.id,
              error: c
            }), h && _this10._actionQueues.enqueue(r.id, function () {
              return new Promise(function (d) {
                var _u2 = function u() {
                  i.off("restart", _u2), _this10._fire("itemRestart", {
                    itemId: r.id
                  }), d();
                };
                i.on("restart", _u2);
              });
            });
          }), i.create(r.sourceElementOrData, r.config, _this10._context);
          throw new Error("Not supported item type: '".concat(r.type, "'."));
        });
      }));
    }
  }, {
    key: "remove",
    value: function remove(t) {
      var _this11 = this;
      var s = m(t);
      return Promise.all(s.map(function (r) {
        return _this11._actionQueues.enqueue(r, function () {
          var i = _this11._getWatchdog(r);
          return _this11._watchdogs.delete(r), i.destroy();
        });
      }));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this12 = this;
      return this._actionQueues.enqueue(l, function () {
        return _this12.state = "destroyed", _this12._fire("stateChange"), _superPropGet(R, "destroy", _this12, 3)([]), _this12._destroy();
      });
    }
  }, {
    key: "_restart",
    value: function _restart() {
      var _this13 = this;
      return this._actionQueues.enqueue(l, function () {
        return _this13.state = "initializing", _this13._fire("stateChange"), _this13._destroy().catch(function (t) {
          console.error("An error happened during destroying the context or items.", t);
        }).then(function () {
          return _this13._create();
        }).then(function () {
          return _this13._fire("restart");
        });
      });
    }
  }, {
    key: "_create",
    value: function _create() {
      var _this14 = this;
      return Promise.resolve().then(function () {
        return _this14._startErrorHandling(), _this14._creator(_this14._contextConfig);
      }).then(function (t) {
        return _this14._context = t, _this14._contextProps = _(_this14._context), Promise.all(Array.from(_this14._watchdogs.values()).map(function (s) {
          return s._setExcludedProperties(_this14._contextProps), s.create(void 0, void 0, _this14._context);
        }));
      });
    }
  }, {
    key: "_destroy",
    value: function _destroy() {
      var _this15 = this;
      return Promise.resolve().then(function () {
        _this15._stopErrorHandling();
        var t = _this15._context;
        return _this15._context = null, _this15._contextProps = new Set(), Promise.all(Array.from(_this15._watchdogs.values()).map(function (s) {
          return s.destroy();
        })).then(function () {
          return _this15._destructor(t);
        });
      });
    }
  }, {
    key: "_getWatchdog",
    value: function _getWatchdog(t) {
      var s = this._watchdogs.get(t);
      if (!s) throw new Error("Item with the given id was not registered: ".concat(t, "."));
      return s;
    }
  }, {
    key: "_isErrorComingFromThisItem",
    value: function _isErrorComingFromThisItem(t) {
      var _iterator9 = _createForOfIteratorHelper(this._watchdogs.values()),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var s = _step9.value;
          if (s._isErrorComingFromThisItem(t)) return !1;
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
      return p(this._context, t.context);
    }
  }]);
}(f);
var T = /*#__PURE__*/function () {
  function T() {
    _classCallCheck(this, T);
    n(this, "_onEmptyCallbacks", []);
    n(this, "_queues", new Map());
    n(this, "_activeActions", 0);
  }
  return _createClass(T, [{
    key: "onEmpty",
    value: function onEmpty(e) {
      this._onEmptyCallbacks.push(e);
    }
  }, {
    key: "enqueue",
    value: function enqueue(e, t) {
      var _this16 = this;
      var s = e === l;
      this._activeActions++, this._queues.get(e) || this._queues.set(e, Promise.resolve());
      var i = (s ? Promise.all(this._queues.values()) : Promise.all([this._queues.get(l), this._queues.get(e)])).then(t),
        a = i.catch(function () {});
      return this._queues.set(e, a), i.finally(function () {
        _this16._activeActions--, _this16._queues.get(e) === a && _this16._activeActions === 0 && _this16._onEmptyCallbacks.forEach(function (c) {
          return c();
        });
      });
    }
  }]);
}();
function m(o) {
  return Array.isArray(o) ? o : [o];
}
export { R as ContextWatchdog, N as EditorWatchdog, f as Watchdog };